import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GetWithdrawalDraftResponse} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetWithdrawalDraftResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalSubmittedExamWithdrawal = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalSubmittedExamWithdrawal = async () => {
    const res = await axiosClient.get<GetWithdrawalDraftResponse>(
        GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_QUERY_KEY,
      getNonNationalSubmittedExamWithdrawal,
      {
        onSuccess,
        onError,
      }
  );
};
